import type { ReactNode } from "react";
import { trackOutboundClick } from "@/lib/track";

type Variant = "primary" | "secondary" | "accent";

export function mailto({
  subject,
  body,
}: {
  subject: string;
  body?: string;
}) {
  const params = new URLSearchParams();
  params.set("subject", subject);
  if (body) params.set("body", body);
  return `mailto:docket@bauerip.com?${params.toString()}`;
}

export function CTAButton({
  href,
  variant = "primary",
  children,
  external,
  trackLabel,
  trackContext,
  className,
}: {
  href: string;
  variant?: Variant;
  children: ReactNode;
  external?: boolean;
  trackLabel?: string;
  trackContext?: string;
  className?: string;
}) {
  const base =
    "inline-flex items-center justify-center px-6 py-3 text-sm font-medium tracking-wide transition-all rounded-full";
  const styles =
    variant === "accent"
      ? "bg-accent text-accent-foreground hover:bg-accent/90 shadow-sm hover:shadow-md"
      : variant === "primary"
      ? "bg-foreground text-primary-foreground hover:bg-foreground/90"
      : "bg-transparent text-foreground border border-foreground/25 hover:border-foreground hover:bg-foreground/5";

  return (
    <a
      href={href}
      className={`${base} ${styles} ${className ?? ""}`}
      onClick={() => {
        if (trackLabel) {
          trackOutboundClick(trackLabel, href, trackContext ? { context: trackContext } : {});
        }
      }}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      {children}
      <span className="ml-2">→</span>
    </a>
  );
}
